import { useGet, UseGetReturnType } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { useMemo } from 'react';
import { Insights } from '../../types/Insights';

const DEFAULT_VALUE = {
    newPairedUsers: 0,
    newPairedDevices: 0,
    totalProtectedUsers: 0,
    totalPairedUsers: 0,
    totalPendingUsers: 0,
    totalExcludedUsers: 0,
    activePairedUsers: 0,
    totalDeviceTokens: 0,
    totalUnpairedUsers: 0,
    tokenTypeToCountMap: [{ type: 0, count: 0 }]
};

interface InsightsDto {
    newPairedUsers: number;
    newPairedDevices: number;
    totalProtectedUsers: number;
    tokenTypeToCountMap: { type: number; count: number }[];
    totalDeviceTokens: number;
    totalPairedUsers: number;
    totalPendingUsers: number;
    totalExcludedUsers: number;
    totalUnpairedUsers: number;
    activePairedUsers: number;
}

type ReturnType = Omit<UseGetReturnType<unknown>, 'data'> & {
    insights: Insights;
};

const convertInsightsDtoToInsights = (data: InsightsDto): Insights => {
    return {
        newPairedUsers: data.newPairedUsers,
        newPairedDevices: data.newPairedDevices,
        totalProtectedUsers: data.totalProtectedUsers,
        totalPairedUsers: data.totalPairedUsers,
        totalPendingUsers: data.totalPendingUsers,
        totalExcludedUsers: data.totalExcludedUsers,
        activePairedUsers: data.activePairedUsers,
        totalDeviceTokens: data.totalDeviceTokens,
        tokenTypeToCountMap: data.tokenTypeToCountMap,
        totalUnpairedUsers: data.totalUnpairedUsers
    };
};

const useGetInsights = (): ReturnType => {
    const { data, ...restValues } = useGet<InsightsDto>({ url: `${USER_MANAGEMENT_BASE_URL}/insights` });

    const insights = useMemo(() => {
        if (!data) {
            return DEFAULT_VALUE;
        }

        return convertInsightsDtoToInsights(data);
    }, [data]);

    return { ...restValues, insights };
};

export default useGetInsights;
